import getSettings from './getSettings';
import updateSettings from './updateSettings';
import resetUpdateSettingsStatusLoading from './resetUpdateSettingsStatusLoading';

const operations = {
  getSettings,
  updateSettings,
  resetUpdateSettingsStatusLoading
};

export default operations;

